import { render, staticRenderFns } from "./SignUpForm.vue?vue&type=template&id=5d97b080&scoped=true&"
import script from "./SignUpForm.vue?vue&type=script&lang=js&"
export * from "./SignUpForm.vue?vue&type=script&lang=js&"
import style0 from "./SignUpForm.vue?vue&type=style&index=0&id=5d97b080&lang=scss&scoped=true&"
import style1 from "./SignUpForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d97b080",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCardText,VForm,VIcon,VLayout,VTextField,VTooltip})
